// MODERNARO — JS propio (mt-*). Vanilla, sin dependencias.
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initGaleriaProducto();
  initVariantesProducto();
  initComoUsarTabs();
  initAngulosCarrusel();
  initResenasCarrusel();
});

// ---------- Reveal on scroll (compartido por todas las secciones) ----------
function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

// ---------- Cifras animadas (count-up) ----------
function initContador() {
  var els = document.querySelectorAll('[data-mt-count]');
  if (!els.length) return;
  var animar = function (el) {
    var fin = parseFloat(el.getAttribute('data-mt-count'));
    var decimales = (el.getAttribute('data-mt-count').split('.')[1] || '').length;
    var dur = 1400;
    var inicio = null;
    function paso(ts) {
      if (!inicio) inicio = ts;
      var p = Math.min((ts - inicio) / dur, 1);
      var val = fin * (1 - Math.pow(1 - p, 3));
      el.textContent = val.toFixed(decimales);
      if (p < 1) requestAnimationFrame(paso);
      else el.textContent = fin.toFixed(decimales);
    }
    requestAnimationFrame(paso);
  };
  if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { animar(entry.target); obs.unobserve(entry.target); }
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { obs.observe(el); });
}

// ---------- Galería de producto: carril con scroll nativo (swipe, trackpad y flechas) ----------
function initGaleriaProducto() {
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;
  var track = wrap.querySelector('[data-mt-galeria-track]');
  var slides = Array.prototype.slice.call(wrap.querySelectorAll('[data-mt-galeria-slide]'));
  var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-mt-galeria-thumb]'));
  var prevBtn = wrap.querySelector('[data-mt-galeria-prev]');
  var nextBtn = wrap.querySelector('[data-mt-galeria-next]');
  var contador = wrap.querySelector('[data-mt-galeria-contador-actual]');
  if (!track || !slides.length) return;

  var total = slides.length;

  function indiceActual() {
    if (track.clientWidth === 0) return 0;
    return Math.round(track.scrollLeft / track.clientWidth);
  }

  function irA(nuevoIndice) {
    var indice = Math.max(0, Math.min(total - 1, nuevoIndice));
    track.scrollTo({ left: track.clientWidth * indice, behavior: 'smooth' });
  }

  function actualizarUI() {
    var indice = indiceActual();
    thumbs.forEach(function (t, i) { t.classList.toggle('mt-thumb-activa', i === indice); });
    if (thumbs[indice] && thumbs[indice].scrollIntoView) {
      thumbs[indice].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
    if (contador) contador.textContent = indice + 1;
  }

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { irA(i); });
  });
  if (prevBtn) prevBtn.addEventListener('click', function () { irA(indiceActual() - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { irA(indiceActual() + 1); });

  var scrollTimer = null;
  track.addEventListener('scroll', function () {
    if (scrollTimer) clearTimeout(scrollTimer);
    scrollTimer = setTimeout(actualizarUI, 80);
  }, { passive: true });

  window.addEventListener('resize', function () { track.scrollLeft = track.clientWidth * indiceActual(); });
}

// ---------- Selector de variantes ----------
function initVariantesProducto() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var dataEl = form.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-mt-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = form.querySelector('[data-mt-precio]');
  var precioCompareEl = form.querySelector('[data-mt-precio-compare]');
  var btn = form.querySelector('[data-mt-add-btn]');

  function moneda(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
    });
  }

  function actualizar() {
    var valores = [];
    selects.forEach(function (s) { valores.push(s.value); });
    var match = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === valores[i]; });
    });
    if (!match) return;
    idInput.value = match.id;
    if (precioEl) precioEl.textContent = moneda(match.price);
    if (precioCompareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        precioCompareEl.textContent = moneda(match.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (btn) {
      if (match.available) {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-mt-texto-add');
      } else {
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-mt-texto-agotado');
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

// ---------- Tabs de "cómo se usa" (por si el diseño usa tabs en vez de scroll) ----------
function initComoUsarTabs() {
  var wrap = document.querySelector('[data-mt-pasos-tabs]');
  if (!wrap) return;
  var tabs = wrap.querySelectorAll('[data-mt-paso-tab]');
  var paneles = wrap.querySelectorAll('[data-mt-paso-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var idx = tab.getAttribute('data-mt-paso-tab');
      tabs.forEach(function (t) { t.classList.remove('mt-activo'); });
      paneles.forEach(function (p) { p.classList.remove('mt-activo'); });
      tab.classList.add('mt-activo');
      var panel = wrap.querySelector('[data-mt-paso-panel="' + idx + '"]');
      if (panel) panel.classList.add('mt-activo');
    });
  });
}

// ---------- Carrusel de ángulos del producto (drag + botones) ----------
function initAngulosCarrusel() {
  document.querySelectorAll('[data-mt-carrusel]').forEach(function (track) {
    var prev = track.parentElement.querySelector('[data-mt-carrusel-prev]');
    var next = track.parentElement.querySelector('[data-mt-carrusel-next]');
    var scrollBy = function (dir) {
      var card = track.querySelector('.mt-carrusel-item');
      var dist = card ? card.getBoundingClientRect().width + 20 : 300;
      track.scrollBy({ left: dir * dist, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
  });
}

// ---------- Carrusel de reseñas (marquesina o manual) ----------
function initResenasCarrusel() {
  document.querySelectorAll('[data-mt-resenas-track]').forEach(function (track) {
    var prev = track.parentElement.querySelector('[data-mt-resenas-prev]');
    var next = track.parentElement.querySelector('[data-mt-resenas-next]');
    var scrollBy = function (dir) {
      var card = track.querySelector('.mt-resena-card');
      var dist = card ? card.getBoundingClientRect().width + 20 : 320;
      track.scrollBy({ left: dir * dist, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
  });
}
